import { render, staticRenderFns } from "./AppEditor.vue?vue&type=template&id=a4ef5e1a&"
import script from "./AppEditor.vue?vue&type=script&lang=js&"
export * from "./AppEditor.vue?vue&type=script&lang=js&"
import style0 from "./AppEditor.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports